<template>
  <v-layout row justify-center>
    <v-dialog
      v-model="dialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <template v-slot:activator="{ on }">
        <v-tooltip top>
          <template v-slot:activator="{ on: tooltipOn }">
            <v-btn
              color="primary"
              fab
              small
              dark
              v-on="{ ...on, ...tooltipOn }"
              @click="searchList()"
              ><v-icon dark>cloud_download</v-icon></v-btn
            >
          </template>
          <span>Admit Card</span>
        </v-tooltip>
      </template>
      <v-card>
        <v-toolbar dark color="primary">
          <v-toolbar-title>Admit Card By Subject</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn color="red" fab small dark @click="cleaRData()">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card color="white">
          <div style="display:flex; padding:20px;">
            <h4>
              {{ collegeData.college_code }} - {{ collegeData.college_name }}
            </h4>
            <v-spacer></v-spacer>
            <h4>Total Examinee: {{ collegeData.student_count }}</h4>
          </div>
        </v-card>
        <v-divider></v-divider>
        <v-card color="white">
          <v-layout row>
            <v-flex xs12>
              <v-card
                flat
                class="margin-auto"
                v-if="getAdmitCardDataBySubject.length > 0"
              >
                <v-card-text>
                  <template>
                    <v-data-table
                      :headers="headers"
                      :items="getAdmitCardDataBySubject"
                      class="elevation-1"
                      hide-actions
                    >
                      <template v-slot:items="props">
                        <td class="text-xs-center">{{ props.index + 1 }}</td>
                        <td class="text-xs-left">
                          {{ props.item.subject_code }}
                          - {{ props.item.subject_name }}
                        </td>
                        <td class="text-xs-center">
                          <table style="margin-top: -4px; width: 100%;">
                            <thead>
                              <tr style="height: 5px; width: 100%;">
                                <th
                                  v-for="items in getadmitInstallmentsDataSet.data"
                                  :key="items.id"
                                  style="font-size: 12px; border: none; height: 30px;border: 2px solid #000;"
                                >
                                  {{ items.title }}
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td
                                  v-for="items in getadmitInstallmentsDataSet.data"
                                  style="border: 1px solid #fffffffc;"
                                >
                                  <span
                                    v-for="itemsData in props.item.installments"
                                  >
                                    <span v-if="itemsData.total_students != 0">
                                      <!-- Tooltip for Admit Card -->
                                      <v-tooltip right>
                                        <template v-slot:activator="{ on }">
                                          <v-btn
                                            v-if="
                                              items.installment_no ==
                                                itemsData.installment_no
                                            "
                                            color="primary"
                                            small
                                            v-on="on"
                                            @click="
                                              downloadAdmit(
                                                props.item,
                                                items.installment_no
                                              )
                                            "
                                          >
                                            Admit (

                                            <span
                                              v-if="
                                                items.installment_no ==
                                                  itemsData.installment_no
                                              "
                                              >{{
                                                itemsData.total_students
                                              }}</span
                                            >

                                            )
                                            <v-icon right dark
                                              >cloud_download</v-icon
                                            >
                                          </v-btn>
                                        </template>
                                        <span>Download Admit Card</span>
                                      </v-tooltip>

                                      <!-- Tooltip for Attendance Sheet -->
                                      <v-tooltip right>
                                        <template v-slot:activator="{ on }">
                                          <v-btn
                                            v-if="
                                              items.installment_no ==
                                                itemsData.installment_no
                                            "
                                            color="primary"
                                            small
                                            dark
                                            v-on="on"
                                            @click="
                                              downloadAttendanceSheet(
                                                props.item,
                                                items.installment_no
                                              )
                                            "
                                          >
                                            Att. sheet
                                            <v-icon right dark
                                              >cloud_download</v-icon
                                            >
                                          </v-btn>
                                        </template>
                                        <span>Download Attendance Sheet</span>
                                      </v-tooltip>

                                      <!-- Tooltip for Descriptive Roll Sheet -->
                                      <v-tooltip right>
                                        <template v-slot:activator="{ on }">
                                          <v-btn
                                            v-if="
                                              items.installment_no ==
                                                itemsData.installment_no
                                            "
                                            color="primary"
                                            small
                                            dark
                                            v-on="on"
                                            @click="
                                              downLoadrollDescriptive(
                                                props.item,
                                                items.installment_no
                                              )
                                            "
                                          >
                                            DRS
                                            <v-icon right dark
                                              >cloud_download</v-icon
                                            >
                                          </v-btn>
                                        </template>
                                        <span
                                          >Download Descriptive Roll Sheet</span
                                        >
                                      </v-tooltip>
                                    </span>
                                    <span
                                      v-if="
                                        itemsData.total_students == 0 &&
                                          items.installment_no ==
                                            itemsData.installment_no
                                      "
                                    >
                                      No Admit Card Available
                                    </span>
                                  </span>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      </template>
                    </v-data-table>
                  </template>
                </v-card-text>
              </v-card>
              <v-card v-else class="margin-auto">
                <v-card-text
                  ><v-flex md12 style="text-align: center;">
                    <v-alert :value="true" color="warning">
                      Admit card is not available at this moment.
                    </v-alert>
                  </v-flex></v-card-text
                >
              </v-card>
            </v-flex>
          </v-layout>
        </v-card>
      </v-card>
    </v-dialog>
  </v-layout>
</template>
<script>
import commonGet from "../../mixin/common_getters_mixin";
import commonExamYear from "../../mixin/exam_year_watch_mixin";
export default {
  mixins: [commonGet, commonExamYear],
  props: ["collegeData"],
  data() {
    return {
      dialog: false,
      notifications: false,
      sound: true,
      widgets: false,
      headers: [
        { text: "SL.", align: "center", value: "id", sortable: false },
        { text: "Subject code & Name", value: "subject_code", sortable: false },
        { text: "Download", align: "center", value: "view", sortable: false },
      ],
      dataSet: [],
    };
  },
  computed: {
    getAdmitCardDataBySubject() {
      return this.$store.getters.getAdmitCardDataBySubject;
    },
    getadmitInstallmentsDataSet() {
      return this.$store.getters.getAdmitCardInstallmentData;
    },
  },

  methods: {
    fetchAdmitInstallmentDatalist() {
      let peram = {};
      peram.exam_initiate_id = this.getExamInitiateId;
      peram.exam_code = this.getLoggedInExam.code;
      peram.exam_year = this.getLoggedInYear.year;
      console.log("This is Load Data", peram);
      this.loading = true;
      this.$store.dispatch("fetchAdmitInstallmentData", peram).then(() => {
        this.loading = false;
      });
    },
    searchList() {
      this.fetchAdmitInstallmentDatalist();
      let dataList = {
        exam_initiate_id: this.getExamInitiateId,
        exam_code: this.getLoggedInExam.code,
        exam_year: this.getLoggedInYear.year,
        college_code: this.collegeData.college_code,
        exam_type: 1,
      };
      console.log("Tanvir! Called", dataList);
      try {
        this.$store
          .dispatch("fetchAdminAdmitCardDataBySubject", dataList)
          .then((data) => {
            this.loading = false;
          });
      } catch (error) {
        console.log("uniuerror", error.response);
      }
    },
    downloadAdmit(item, inst_no) {
      const param = {
        exam_code: this.getLoggedInExam.code,
        subject_code: item.subject_code,
        exam_year: this.getLoggedInYear.year,
        college_code: this.collegeData.college_code,
        module_name: "Admin",
        adm_installment_no: inst_no,
      };

      this.$store
        .dispatch("downloadAdmitCollegewise2", param)
        .then((result) => {
          const blob = new Blob([result], { type: "application/pdf" });

          const url = window.URL.createObjectURL(blob);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            `${item.exam_code}_${item.year}_${item.college_code}_${item.subject_code}-signed.pdf`
          );

          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        })
        .catch((error) => {
          console.error("Tanvir! Download failed", error);
        });
    },

    downloadAttendanceSheet(item, id) {
      const {
        college_code,
        center_code,
        subject_code,
        exam_initiate_id,
        exam_code,
        year,
      } = item;

      const param = {
        college_code,
        center_code,
        subject_code,
        exam_initiate_id,
        exam_code,
        year,
        adm_installment_no: id,
      };

      this.$store
        .dispatch("examWiseAttendanceSheet2", param)
        .then((result) => {
          if (!result) throw new Error("Empty response from server.");

          const blob = new Blob([result], { type: "application/pdf" });
          const url = URL.createObjectURL(blob);

          const link = document.createElement("a");
          link.href = url;
          link.download = `${exam_code}_${year}_${college_code}_att-signed.pdf`;

          document.body.appendChild(link);
          link.click();

          // Clean up
          document.body.removeChild(link);
          URL.revokeObjectURL(url);
        })
        .catch((error) => {
          console.error("Tanvir! Download failed ❌", error);
        });
    },

    downLoadrollDescriptive(item, id) {
      //console.log("pr item", item);
      //return false;
      let param = {};
      param.college_code = item.college_code;
      param.center_code = item.center_code;
      param.subject_code = item.subject_code;
      param.exam_initiate_id = item.exam_initiate_id;
      param.exam_code = item.exam_code;
      param.year = item.year;
      (param.adm_installment_no = id),
        this.$store
          .dispatch("examWiseDescriptiveRollSheet2", param)
          .then((result) => {
            const blob = new Blob([result], { type: "application/pdf" });

            const url = window.URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute(
              "download",
              `${item.exam_code}_${item.year}_${item.college_code}_dsp-signed.pdf`
            );
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
          })
          .catch((error) => {
            console.error("Tanvir! Download failed", error);
          });
    },

    cleaRData() {
      this.$store.commit("SET_ADMIT_CARD_DATA_BY_SUBJECT", []);
      this.dialog = false;
    },
  },
};
</script>
<style lang=""></style>
